<template>
  <CardModule title="Dados Cadastrais">
    <v-row>
      <v-col cols="6">
        <BaseSelect
          required
          tabindex="1"
          label="Tipo"
          item-text="value"
          item-value="key"
          placeholder="Selecione o tipo do produto"
          :clearable="false"
          :rules="[rules.required]"
          :items="$produtos_gerenciar.tipos_produtos"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.tipo"
        />
      </v-col>
      <v-col cols="6">
        <BaseTextField
          required
          tabindex="2"
          counter
          label="Descrição"
          placeholder="Ex: Bilhete Inteira"
          :maxlength="65"
          :rules="[rules.required, rules.max(65)]"
          v-model="
            $produtos_gerenciar.cadastro.dados_cadastrais.descricao_pt_br
          "
        >
          <v-tooltip bottom slot="append">
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                color="secondary"
                @click="$config.ModalTraducoes('produto_descricao')"
              >
                mdi-flag-outline
              </v-icon>
            </template>
            <span>Traduções</span>
          </v-tooltip>
        </BaseTextField>
      </v-col>
    </v-row>
    <template v-if="isACommonProduct">
      <CommonProduct />
    </template>
    <template v-if="isAIFrameProduct">
      <IFrameProduct />
    </template>
    <template v-if="isALinkProduct">
      <LinkProduct />
    </template>
    <template v-if="isARechargeProduct">
      <RechargeProduct />
    </template>
  </CardModule>
</template>

<script>
import mixins from "@/mixins";
import CardModule from "@/components/cards/CardModule.vue";
import BaseSelect from "@/components/forms/BaseSelect.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import CommonProduct from "@/components/produtos/gerenciar/CommonProduct.vue";
import IFrameProduct from "@/components/produtos/gerenciar/IFrameProduct.vue";
import LinkProduct from "@/components/produtos/gerenciar/LinkProduct.vue";
import RechargeProduct from "@/components/produtos/gerenciar/RechargeProduct.vue";

const { products, formRules } = mixins;

export default {
  name: "RegistrationData",
  mixins: [products, formRules],
  components: {
    CardModule,
    BaseSelect,
    BaseTextField,
    CommonProduct,
    IFrameProduct,
    LinkProduct,
    RechargeProduct,
  },
  data() {
    return {
      descricao: "",
      descritivo: "",
      limitarIngressos: false,
      rulesDescricao: [
        v =>
          v.length <= 65 ||
          "A descrição do produto não pode ter mais de 65 caracteres!",
      ],
      rulesDescritivo: [
        v =>
          v.length <= 1500 ||
          "O descritivo do produto não pode ter mais de 1500 caracteres!",
      ],
    };
  },
  methods: {
    openDescriptionModal() {
      this.$produtos_gerenciar.descriptionModal = true;
    },
  },
  watch: {
    "$produtos_gerenciar.cadastro.dados_cadastrais.descricao_pt_br": function (
      e
    ) {
      this.$produtos_gerenciar.cadastro.dados_cadastrais.sku =
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo.substring(
          0,
          2
        ) +
        e.substring(0, 2).toUpperCase() +
        this.$produtos_gerenciar.cadastro.dados_cadastrais.categoria
          .substring(0, 2)
          .toUpperCase() +
        Math.floor(Math.random() * 99999 + 1);
    },
    "$produtos_gerenciar.cadastro.dados_cadastrais.tipo": function (e) {
      this.$produtos_gerenciar.cadastro.dados_cadastrais.sku =
        e.substring(0, 2) +
        this.$produtos_gerenciar.cadastro.dados_cadastrais.descricao_pt_br
          .substring(0, 2)
          .toUpperCase() +
        this.$produtos_gerenciar.cadastro.dados_cadastrais.categoria
          .substring(0, 2)
          .toUpperCase() +
        Math.floor(Math.random() * 99999 + 1);
      if (e === "VOUCHER" || e === "RECARGA") {
        this.descricao = "Produto";
        this.descritivo = "Descrição";
        this.$produtos_gerenciar.cadastro.variacoes.gerenciar_lote = false;
      } else if (e === "INGRESSO" || e === "CORTESIA") {
        this.descricao = "Evento";
        this.descritivo = "Descrição do evento";
      } else {
        this.descricao = "Título do Produto";
      }
    },
    "$produtos_gerenciar.cadastro.dados_cadastrais.categoria": function (e) {
      this.$produtos_gerenciar.cadastro.dados_cadastrais.sku =
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo.substring(
          0,
          2
        ) +
        this.$produtos_gerenciar.cadastro.dados_cadastrais.descricao_pt_br
          .substring(0, 2)
          .toUpperCase() +
        e.substring(0, 2).toUpperCase() +
        Math.floor(Math.random() * 99999 + 1);
    },
    "$produtos_gerenciar.cadastro.dados_cadastrais.dthr_apresentacao"(e) {
      if (e == "") {
        this.$produtos_gerenciar.cadastro.dados_cadastrais.dthr_apresentacao =
          null;
      }
    },
    "$produtos_gerenciar.cadastro.dados_cadastrais.limitarIngressos"(e) {
      if (e == false) {
        this.$produtos_gerenciar.cadastro.dados_cadastrais.limite_venda_cpf = 0;
      }
    },
  },
  computed: {
    isACommonProduct() {
      return (
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo ===
          "INGRESSO" ||
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo ===
          "CORTESIA" ||
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo === "VOUCHER"
      );
    },
    isAIFrameProduct() {
      return (
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo === "IFRAME"
      );
    },
    isALinkProduct() {
      return this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo === "LINK";
    },
    isARechargeProduct() {
      return (
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo === "RECARGA"
      );
    },
  },
  mounted() {
    this.$config.getPaises();
    if (
      this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo === "VOUCHER" ||
      this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo === "RECARGA"
    ) {
      this.descricao = "Produto";
      this.descritivo = "Descrição";
    } else if (
      this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo === "INGRESSO" ||
      this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo === "CORTESIA"
    ) {
      this.descricao = "Evento";
      this.descritivo = "Descrição do evento";
    } else {
      this.descricao = "Título do Produto";
    }
    this.$produtos_gerenciar.getStatusProdutos();

    this.$produtos_gerenciar.getTiposProdutos();
    this.$produtos_gerenciar.getCanaisVenda();
    this.$produtos_gerenciar.getProdutosCategoria();

    // AJUSTAR ISSO QUANDO UPLOAD DE IMAGENS NO SYNC FILE ESTIVER OK
    // this.$produtos_gerenciar.categorias_produtos = this.$axios.getLocal('categorias-produtos').data
  },
  destroyed() {
    this.$produtos_gerenciar.descriptionTranslate = false;
    this.$produtos_gerenciar.cadastro.dados_cadastrais.descritivo = "";
    (this.$produtos_gerenciar.cadastro.dados_cadastrais.error.descricao = ""),
      (this.$produtos_gerenciar.cadastro.dados_cadastrais.error.descritivo =
        ""),
      (this.$produtos_gerenciar.cadastro.dados_cadastrais.error.status = ""),
      (this.$produtos_gerenciar.cadastro.dados_cadastrais.error.canal_venda =
        ""),
      (this.$produtos_gerenciar.cadastro.dados_cadastrais.error.loja = ""),
      (this.$produtos_gerenciar.cadastro.dados_cadastrais.error.limite_venda_cpf =
        ""),
      (this.$produtos_gerenciar.cadastro.dados_cadastrais.error.tipo = ""),
      (this.$produtos_gerenciar.cadastro.dados_cadastrais.error.preco = ""),
      (this.$produtos_gerenciar.cadastro.dados_cadastrais.error.estoque = ""),
      (this.$produtos_gerenciar.cadastro.dados_cadastrais.error.preco_promocional =
        ""),
      (this.$produtos_gerenciar.cadastro.dados_cadastrais.error.categoria = ""),
      (this.$produtos_gerenciar.cadastro.dados_cadastrais.error.sku = ""),
      (this.$produtos_gerenciar.cadastro.dados_cadastrais.error.dthr_apresentacao =
        ""),
      (this.$produtos_gerenciar.cadastro.dados_cadastrais.limitarIngressos = false),
      /**
       * @description Bloco de dados regra de acesso
       */
      (this.$produtos_gerenciar.cadastro.regra_acesso.error.dias_antes = ""),
      (this.$produtos_gerenciar.cadastro.regra_acesso.error.horas_antes = ""),
      (this.$produtos_gerenciar.cadastro.regra_acesso.error.dias_depois = ""),
      (this.$produtos_gerenciar.cadastro.regra_acesso.error.horas_depois = ""),
      (this.$produtos_gerenciar.cadastro.regra_acesso.error.limite_uso = ""),
      /**
       * @description Bloco de dados período de vendas
       */
      (this.$produtos_gerenciar.cadastro.periodo_vendas.error.data_inicio = ""),
      (this.$produtos_gerenciar.cadastro.periodo_vendas.error.hora_inicio = ""),
      (this.$produtos_gerenciar.cadastro.periodo_vendas.error.data_termino =
        ""),
      (this.$produtos_gerenciar.cadastro.periodo_vendas.error.hora_termino =
        "");
    /**
     * @description Bloco de dados variações
     */
    (this.$produtos_gerenciar.cadastro.variacoes.error.tipo = ""),
      /**
       * @description Bloco de dados customização
       */
      (this.$produtos_gerenciar.cadastro.customizacao.error.imagem = ""),
      /**
       * @description Bloco de dados pré-vizualização
       */
      (this.$produtos_gerenciar.cadastro.pre_visualizacao.error.slug = "");
  },
};
</script>

<style scoped></style>
